import React from 'react';
import cn from 'classnames';
import { Checkbox } from '@components/FormInputs';
import { EditorBlock } from 'draft-js';
import styles from './CheckableListItem.module.scss';

export default class CheckableListItem extends React.Component<any> {
  render() {
    const {
      offsetKey,
      blockProps: { onChangeChecked, checked },
    } = this.props;

    return (
      <div className={cn(styles.container)} data-offset-key={offsetKey}>
        <Checkbox
          className={styles.checkbox}
          id={`checkableListItem_${offsetKey}`}
          onChange={onChangeChecked}
          checked={checked}
        />
        <div className={styles.text}>
          <EditorBlock {...this.props} />
        </div>
      </div>
    );
  }
}
